import React from 'react';
import {StyleSheet, View} from 'react-native';

import AmexIcon from '../../../../images/brand/svg/icons/Amex.svg';
import MastercardIcon from '../../../../images/brand/svg/icons/Mastercard.svg';
import VisaIcon from '../../../../images/brand/svg/icons/Visa.svg';

function CardIcons() {
  return (
    <View style={styles.containerStyle}>
      <View style={styles.shadow}>
        <VisaIcon style={styles.icon} />
      </View>
      <View style={styles.shadow}>
        <MastercardIcon style={styles.icon} />
      </View>
      {/* <View style={styles.shadow}>
        <AmexIcon style={styles.icon} />
      </View> */}
    </View>
  );
}

export default CardIcons;

const styles = StyleSheet.create({
  containerStyle: {
    flexDirection: 'row',
    gap: 4,
    height: 25,
  },
  icon: {
    width: 32,
    height: 25,
  },
  shadow: {
    shadowColor: 'black',
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowOpacity: 0.07,
    shadowRadius: 20,
  },
});
